import fr1 from "../assets/images/for-her/image-1.png";
import fr2 from "../assets/images/for-her/image-2.png";
import fr3 from "../assets/images/for-her/image-3.png";
import fr4 from "../assets/images/for-her/image-4.png";
import fr5 from "../assets/images/for-her/image-5.png";
import fr6 from "../assets/images/for-her/image-6.png";

// For Her images grid
export const forHerImages = [
    { src: fr4, name: 'Velvet Rose', category: 'For Her', price: '$95' },
    { src: fr2, name: 'Golden Jasmine', category: 'For Her', price: '$110' },
    { src: fr3, name: 'Blossom Dream', category: 'For Her', price: '$85' },
    { src: fr1, name: 'Amber Queen', category: 'For Her', price: '$120' },
    { src: fr5, name: 'Pearl Essence', category: 'For Her', price: '$105' },
    { src: fr6, name: 'Royal Bloom', category: 'For Her', price: '$130' },
];
